export default __webpack_public_path__ + "static/media/Die_2.d847ff48.png";